import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {LoginRequest} from "../models/login-request";
import {BehaviorSubject, catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {Token} from "../models/token";
import {StorageService} from "../../../core/services/storage.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private handlerErro: HandlerError;
  private readonly TOKEN_KEY: string = 'juridico.user.service';
  private loggedIn = new BehaviorSubject<boolean>(false);
  private participantChanges = new BehaviorSubject<Token | undefined>(this.AccessToken);


  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService,
    private storageService: StorageService,
    private router: Router) {
    this.handlerErro = httpErrorHandler.createHandleError(`AuthService`);
  }

  baseUrl = environment.apiUrl;

  login(request: LoginRequest): Observable<BaseResponse<Token> | BaseResponse<any>>{
    console.log('Iniciando chamada de login para:', this.baseUrl + '/Token');
    return this.http
      .post<BaseResponse<Token>>(this.baseUrl + '/Token', request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('login')));
  }

  logoff(){
    this.removeAccessToken();
    this.router.navigate([`/auth/login/`]);
  }

  isTokenExpired(): boolean {
    const token = this.AccessToken;
    if (!token || !token.accessToken || !token.expires) {
      return true;
    }

    const dataHoje = new Date();
    const dataExpiracao = new Date(token.expires);

    return dataHoje >= dataExpiracao;
  }

  setAccessToken(token: Token): void {
    this.storageService.setTypedItem(this.TOKEN_KEY, token);
    this.loggedIn.next(true);
    this.participantChanges.next(token);
  }

  get AccessToken(): Token | undefined {
    return this.storageService.getTypedItem<Token>(this.TOKEN_KEY);
  }

  get isLoggedIn(): Observable<boolean> {
    const token = this.AccessToken;
    if (token && !this.isTokenExpired()) {
      this.loggedIn.next(true);
    } else {
      this.loggedIn.next(false);
    }
    return this.loggedIn.asObservable();
  }

  get currentUser(): Observable<Token | undefined> {
    return this.participantChanges.asObservable();
  }

  private removeAccessToken(): void {
    this.storageService.removeItem(this.TOKEN_KEY);
    this.loggedIn.next(false);
    this.participantChanges.next(undefined);
  }

}
